(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.factory:Username
   *
   * @description
   *
   */
  angular
  .module('neo.services')
  .factory('Username', Username);

  function Username($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/user/username', {}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());
